import Flyer1 from "../../img/Flyer1.webp"
import Flyer2 from "../../img/Flyer2.webp"
import Flyer3 from "../../img/Flyer3.webp"
import Flyer4 from "../../img/1611.webp"
import Flyer5 from "../../img/Art-spiritualite.webp"
import Flyer6 from "../../img/Flyer6.webp"
import Flyer7 from "../../img/Flyer7.webp"
import Flyer8 from "../../img/Flyer8.webp"
import Flyer9 from "../../img/22_03_25.webp"
import Flyer10 from "../../img/29_03_25.webp"
import Flyer11 from "../../img/Flyer11.webp"
import Flyer12 from "../../img/Flyer12.webp"
import Flyer13 from "../../img/Flyer13.webp"
import Flyer14 from "../../img/Flyer14.webp"
import Flyer15 from "../../img/Flyer15.webp"
import Flyer16 from "../../img/Flyer16.webp"

const eventsData = [
    {
      id: 1,
      slug: "evenement-1",
      title: "Événement 1",
      img: Flyer4,
      date: "2024-11-16",
      lieu: "",
      heure: "",
      description: "",
      speaker: "",
      inscriptionUrl: null,
      href: "/evenement/evenement-1",
    },
    {
      id: 2,
      slug: "evenement-2",
      title: "Événement 2",
      img: Flyer3,
      date: "2024-11-15",
      lieu: "",
      heure: "",
      description: "",
      speaker: "",
      inscriptionUrl: null,
      href: "/evenement/evenement-2",
    },
    {
      id: 3,
      slug: "evenement-3",
      title: "Événement 3",
      img: Flyer1,
      date: "2024-11-10",
      lieu: "",
      heure: "",
      description: "",
      speaker: "",
      inscriptionUrl: null,
      href: "/evenement/evenement-3",
    },
    {
      id: 4,
      slug: "evenement-4",
      title: "Événement 4",
      img: Flyer2,
      date: "2024-11-10",
      lieu: "",
      heure: "",
      description: "",
      speaker: "",
      inscriptionUrl: null,
      href: "/evenement/evenement-4",
    },
    {
      id: 5,
      slug: "evenement-5",
      title: "Événement 5",
      img: Flyer5,
      date: "2024-12-14",
      lieu: "",
      heure: "",
      description: "",
      speaker: "",
      inscriptionUrl: null,
      href: "/evenement/evenement-5",
    },
    {
      id: 6,
      slug: "evenement-6",
      title: "Événement 6",
      img: Flyer6,
      date: "2025-01-25",
      lieu: "",
      heure: "",
      description: "",
      speaker: "",
      inscriptionUrl: null,
      href: "/evenement/evenement-6",
    },
    {
      id: 7,
      slug: "evenement-7",
      title: "Événement 7",
      img: Flyer7,
      date: "2025-03-01",
      lieu: "",
      heure: "",
      description: "",
      speaker: "",
      inscriptionUrl: null,
      href: "/evenement/evenement-7",
    },
    {
      id: 8,
      slug: "evenement-8",
      title: "Événement 8",
      img: Flyer8,
      date: "2025-02-22",
      lieu: "",
      heure: "",
      description: "",
      speaker: "",
      inscriptionUrl: null,
      href: "/evenement/evenement-8",
    },
    {
      id: 9,
      slug: "evenement-9",
      title: "Événement 9",
      img: Flyer9,
      date: "2025-03-22",
      lieu: "",
      heure: "",
      description: "",
      speaker: "",
      inscriptionUrl: null,
      href: "/evenement/evenement-9",
    },
    {
      id: 10,
      slug: "evenement-10",
      title: "Événement 10",
      img: Flyer10,
      date: "2025-03-29",
      lieu: "",
      heure: "",
      description: "",
      speaker: "",
      inscriptionUrl: null,
      href: "/evenement/evenement-10",
    },
    {
      id: 11,
      slug: "rencontre-spirituelle-feminine",
      title: "Rencontre spirituelle féminine",
      img: Flyer11,
      date: "2025-04-13",
      lieu: "Salle All Events, 41 boulevard de Thibaud, 31100 Toulouse",
      heure: "13 Avril 2025 — Accueil à 13h30",
      description: "L'association L'Antre-Connaissance vous invite à une rencontre spirituelle exclusivement féminine, un moment d'introspection et d'échange dédié aux femmes en quête d'harmonie intérieure.\n\nAu programme :\n• Conférence inspirante • Méditation • Quizz interactif avec cadeaux • Ateliers enfants • Restauration • Stand de vente •\n\nVenez partager un moment unique de spiritualité et de bienveillance ! Pensez à venir accompagnée de vos proches 🌷\n\n📞 Contact : 07 62 03 41 20",
      speaker: "",
      inscriptionUrl: "https://www.helloasso.com/associations/l-antre-connaissance/evenements/rencontre-spirituelle-feminine/widget",
      href: "/evenement/rencontre-spirituelle-feminine",
    },
    {
      id: 12,
      slug: "evenement-12",
      title: "Événement 12",
      img: Flyer12,
      date: "2025-04-12",
      lieu: "",
      heure: "",
      description: "",
      speaker: "",
      inscriptionUrl: null,
      href: "/evenement/evenement-12",
    },
    {
      id: 13,
      slug: "art-et-spiritualite",
      title: "Art et spiritualité",
      img: Flyer13,
      date: "2025-05-10",
      lieu: "Club Alpin, Toulouse",
      heure: "10 Mai 2025 à 17h30",
      description: "De l'esprit de l'Art à l'art de l'Esprit",
      speaker: "Quentin M.",
      inscriptionUrl: null,
      href: "/evenement/art-et-spiritualite",
    },
    {
      id: 14,
      slug: "introduction-meditation-soufie",
      title: "Introduction à la méditation soufie",
      img: Flyer14,
      date: "2025-05-31",
      lieu: "Espace Allegria, Toulouse",
      heure: "31 Mai 2025 de 17h30 à 19h30",
      description: "Intervenant : Sidi Selim, enseignant dans une voie soufie.",
      speaker: "",
      inscriptionUrl: null,
      href: "/evenement/introduction-meditation-soufie",
    },
    {
      id: 15,
      slug: "cycle-philosophique",
      title: "Cycle philosophique",
      img: Flyer15,
      date: "2026-03-22",
      lieu: "14 rue Saint Bertrand, 31500 Toulouse",
      heure: "1 Fév · 22 Mars · 31 Mai 2026 à 19h00",
      description: "🧠 Cycle philosophique – Les besoins de l'âme\n✨ 1ère rencontre : L'amour, la boisson de l'âme\n\nEn s'inspirant de Simone Weil, mais aussi de Platon et Maeterlinck, nous réfléchirons ensemble à une question essentielle :\n👉 de quoi notre âme a-t-elle réellement besoin pour ne pas s'assécher ?",
      speaker: "Solenne Marchand",
      inscriptionUrl: null,
      href: "/evenement/cycle-philosophique",
    },
    {
      id: 16,
      slug: "conference-philosophique",
      title: "Conférence Philosophique",
      img: Flyer16,
      date: "2026-02-28",
      lieu: "14 rue Saint Bertrand, 31500 Toulouse",
      heure: "28 Février 2026 à 15h00",
      description: "CONFÉRENCE PHILOSOPHIQUE — « Unité de l'expérience mystique »\n\nExiste-t-il une unité dans l'expérience du divin à travers les traditions spirituelles ? Cette conférence propose une étude philosophique et comparative de l'expérience mystique dans l'hindouïsme, le christianisme et l'islam, afin d'explorer leurs convergences et leurs différences.",
      speaker: "Elias Samrakandi",
      inscriptionUrl: null,
      href: "/evenement/conference-philosophique",
    },
  ];

  export default eventsData;
